if (!customElements.get('product-info')) {
    customElements.define(
      'product-info',
      class ProductInfo extends HTMLElement {
        onVariantChangeUnsubscriber = undefined;
        cartUpdateUnsubscriber = undefined;
        abortController = undefined;
        pendingRequestUrl = null;
        preProcessHtmlCallbacks = [];
        postProcessHtmlCallbacks = [];
        readMoreBtn = document.querySelector('.read-more-btn')
        descriptionContent = document.querySelector('.description-content')
        descriptionContainer = document.querySelector('.pdp-details-description-text')
        buyNowButton = document.querySelector('.buy-now');

        constructor() {
          super();
          if (this.readMoreBtn && this.descriptionContent) {
            if (this.descriptionContent.scrollHeight > 105) {
              this.readMoreBtn.style.display = 'inline-block';
            }
  
            this.readMoreBtn.addEventListener('click', () => this.toggleDescription());
          }
        }
  
        connectedCallback() {
          this.initializeProductSwapUtility();
  
          this.onVariantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.optionValueSelectionChange,
            this.handleOptionValueChange.bind(this)
          );
  
          this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

          this.handleProductVariantUpdate();
        }
  
        addPreProcessCallback(callback) {
          this.preProcessHtmlCallbacks.push(callback);
        }
  
        disconnectedCallback() {
          this.onVariantChangeUnsubscriber();
          this.cartUpdateUnsubscriber?.();
        }
  
        initializeProductSwapUtility() {
          this.preProcessHtmlCallbacks.push((html) =>
            html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
          );
          this.postProcessHtmlCallbacks.push((newNode) => {
            window?.Shopify?.PaymentButton?.init();
            window?.ProductModel?.loadShopifyXR();
          });
        }
  
        handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
          if (!this.contains(event.target)) return;
  
          this.resetProductFormState();
  
          const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
          this.pendingRequestUrl = productUrl;
          const shouldSwapProduct = this.dataset.url !== productUrl;
          const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
  
          this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
            targetId: target.id,
            callback: shouldSwapProduct
              ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
              : this.handleUpdateProductInfo(productUrl),
          });
        }

        toggleDescription() {       
          this.descriptionContainer.classList.toggle('expanded');
          this.readMoreBtn.textContent = this.descriptionContainer.classList.contains('expanded') 
            ? 'Read Less' 
            : 'Read More';
        }
  
        resetProductFormState() {
          const productForm = this.productForm;
          productForm?.handleErrorMessage();
        }
  
        handleSwapProduct(productUrl, updateFullPage) {
          return (html) => {
            this.productModal?.remove();
  
            const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
            const variant = this.getSelectedVariant(html.querySelector(selector));
            this.updateURL(productUrl, variant?.id);
  
            if (updateFullPage) {
              document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
  
              HTMLUpdateUtility.viewTransition(
                document.querySelector('main'),
                html.querySelector('main'),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
              );
            } else {
              HTMLUpdateUtility.viewTransition(
                this,
                html.querySelector('product-info'),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
              );
            }
          };
        }
  
        renderProductInfo({ requestUrl, targetId, callback }) {
          this.abortController?.abort();
          this.abortController = new AbortController();
  
          fetch(requestUrl, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
              this.pendingRequestUrl = null;
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              callback(html);
            })
            .then(() => {
              // set focus to last clicked option value
              document.querySelector(`#${targetId}`)?.focus();
            })
            .catch((error) => {
              if (error.name === 'AbortError') {
                console.log('Fetch aborted by user');
              } else {
                console.error(error);
              }
            });
        }
  
        getSelectedVariant(productInfoNode) {
          const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
          return !!selectedVariant ? JSON.parse(selectedVariant) : null;
        }
  
        buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
          const params = [];
  
          !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
  
          if (optionValues.length) {
            params.push(`option_values=${optionValues.join(',')}`);
          }
  
          return `${url}?${params.join('&')}`;
        }
  
        updateOptionValues(html) {
          const variantSelects = html.querySelector('variant-selects');
          if (variantSelects) {
            HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
          }
        }
  
        handleUpdateProductInfo(productUrl) {
          return (html) => {
            const variant = this.getSelectedVariant(html);
            const isVariantAvailable = this.isVariantAvailableForPurchase(variant);
  
            this.pickupAvailability?.update(variant);
            this.updateOptionValues(html);
            this.updateURL(productUrl, variant?.id);
            this.updateVariantInputs(variant?.id, isVariantAvailable);
            this.handleProductVariantUpdate();
  
            if (!variant) {
              document.querySelectorAll('product-form').forEach((productForm) => {
                const submitButton = productForm.querySelector(`.ProductSubmitButton-${this.sectionId}`);
                const submitButtonText = submitButton?.querySelector('span');
                const buyNowButton = productForm.querySelector('.buy-now');
                const buyNowButtonText = buyNowButton?.querySelector('span');

                submitButton?.setAttribute('disabled', 'disabled');
                if (submitButtonText) submitButtonText.textContent = window.variantStrings.soldOut;

                if (buyNowButton) {
                  buyNowButton.style.display = 'none';
                  buyNowButton.setAttribute('disabled', 'disabled');
                  if (buyNowButtonText) buyNowButtonText.textContent = window.variantStrings.soldOut;
                }
              });
              return;
            }
            
            const productForms = document.querySelectorAll('product-form')
            productForms.forEach((productForm) => {
              const submitButton = productForm.querySelector(`.ProductSubmitButton-${this.sectionId}`);
              const submitButtonText = submitButton?.querySelector('span');
              const buyNowButton = productForm.querySelector('.buy-now');
              const buyNowButtonText = buyNowButton?.querySelector('span');
            
              if (isVariantAvailable) {
                submitButton?.removeAttribute('disabled');
                if (buyNowButton) {
                  buyNowButton.style.display = 'block';
                  buyNowButton.removeAttribute('disabled');
                  buyNowButtonText.textContent = window.variantStrings.buyNow;
                }
                if (submitButtonText) { 
                  submitButtonText.textContent = window.variantStrings.addToCart;
                }
              } else {
                submitButton?.setAttribute('disabled', 'disabled');
                if (buyNowButton) {
                  buyNowButton.style.display = 'none';
                  buyNowButton.setAttribute('disabled', 'disabled');
                }
                if (submitButtonText) submitButtonText.textContent = window.variantStrings.soldOut;
              }
            });

            const updateProductPrices = (variant) => {
              let compareAtPriceElement = document.querySelector('[data-testid="pdp-compare-at-price"]');
              const actualPriceElement = document.querySelector('[data-testid="pdp-actual-price"]');
              const priceContainer = document.querySelector('.pdp-details-product-price');
            
              if (variant.compare_at_price && 
                  variant.compare_at_price !== variant.price && 
                  variant.compare_at_price > variant.price) {
                
                if (!compareAtPriceElement && priceContainer) {
                  compareAtPriceElement = document.createElement('div');
                  compareAtPriceElement.setAttribute('data-testid', 'pdp-compare-at-price');
                  compareAtPriceElement.style.textDecoration = 'line-through';
                  
                  priceContainer.insertBefore(compareAtPriceElement, actualPriceElement);
                }
                
                if (compareAtPriceElement) {
                  compareAtPriceElement.textContent = formatMoney(variant.compare_at_price);
                  compareAtPriceElement.style.display = 'block'; 
                }
              } else {
                if (compareAtPriceElement) {
                  compareAtPriceElement.style.display = 'none';
                }
              }
            
              if (actualPriceElement) {
                actualPriceElement.textContent = formatMoney(variant.price);
              }
            };
            
            updateProductPrices(variant);
  
            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: this.sectionId,
                html,
                variant,
              },
            });
          };
        }

        isVariantAvailableForPurchase(variant) {
          if (!variant || variant.available === false) return false;

          const inventoryQuantity = variant.inventory_quantity;
          if (inventoryQuantity === null || inventoryQuantity === undefined || inventoryQuantity === '') return false;

          const numericInventoryQuantity = Number(inventoryQuantity);
          return Number.isFinite(numericInventoryQuantity) && numericInventoryQuantity > 0;
        }

        handleProductVariantUpdate(){
          const inputSelectors = document.querySelectorAll('.pdp-details .input-selector:has(.variant-color), .pdp-details  .input-selector:has(.variant-size)');
          inputSelectors.forEach(selector => {
              const radio = selector.querySelector(".color-radio[type='radio']:checked + label, .size-radio[type='radio']:checked + label");
              if (radio) {
                  const variantColorText = selector.querySelector(".variant-color")?.textContent?.trim();
                  const variantSizeText = selector.querySelector(".variant-size")?.textContent?.trim();
                  if (variantColorText) {
                      const colorSelectedSpan = document.querySelector("fieldset.color .value-selected");
                      if (colorSelectedSpan) {
                          colorSelectedSpan.textContent = variantColorText;
                      }
                  }
                  
                  if (variantSizeText) {
                      const sizeSelectedSpan = document.querySelector("fieldset.size .value-selected");

                      if (sizeSelectedSpan) {
                          sizeSelectedSpan.textContent = variantSizeText;
                      }
                  }
              }
          });
      }
  
        updateVariantInputs(variantId, isAvailable = true) {
          this.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
          ).forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.disabled = !variantId || !isAvailable;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
  
                updateURL(url, variantId) {
          const baseUrl = url.split('?')[0]; // Remove any existing query parameters
          const variantParam = variantId ? `?variant=${variantId}` : '';
          
          this.querySelector('share-button')?.updateUrl(
            `${window.shopUrl}${baseUrl}`
          );

          if (this.dataset.updateUrl === 'false') return;
          window.history.replaceState({}, '', `${baseUrl}${variantParam}`);
        }
  
        get productForm() {
          return this.querySelector(`product-form`);
        }
  
        get pickupAvailability() {
          return this.querySelector(`pickup-availability`);
        }
  
        get variantSelectors() {
          return this.querySelector('variant-selects');
        }
  
        get relatedProducts() {
          const relatedProductsSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'related-products'
          );
          return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
        }
  
        get quickOrderList() {
          const quickOrderListSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'quick_order_list'
          );
          return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
        }
  
    
        get relatedProducts() {
          const relatedProductsSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'related-products'
          );
          return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
        }
  
        get quickOrderList() {
          const quickOrderListSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'quick_order_list'
          );
          return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
        }
  
        get sectionId() {
          return this.dataset.originalSection || this.dataset.section;
        }
      }
    );
  }

  class HTMLUpdateUtility {
    /**
     * Used to swap an HTML node with a new node.
     * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
     *
     * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
     */
    static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
      preProcessCallbacks?.forEach((callback) => callback(newContent));
  
      const newNodeWrapper = document.createElement('div');
      HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
      const newNode = newNodeWrapper.firstChild;
  
      // dedupe IDs
      const uniqueKey = Date.now();
      oldNode.querySelectorAll('[id], [form]').forEach((element) => {
        element.id && (element.id = `${element.id}-${uniqueKey}`);
        element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
      });
  
      oldNode.parentNode.insertBefore(newNode, oldNode);
      oldNode.style.display = 'none';
  
      postProcessCallbacks?.forEach((callback) => callback(newNode));
  
      setTimeout(() => oldNode.remove(), 500);
    }
  
    // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    static setInnerHTML(element, html) {
      element.innerHTML = html;
      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
  }
  
  
